import Login from "../views/auth/Login";
import Register from "../views/auth/Register";
import ResetPassword from "../views/auth/ResetPassword";
import ImpersonateLogin from "../views/auth/ImpersonateLogin";
import SetupTwoFactor from "../views/auth/SetupTwoFactor";
import InviteUserAction from "../views/user/InviteUserAction";
import InviteProfessionalAction from "../views/professional/InviteProfessionalAction";
import InviteRedirect from "../views/invite/InviteRedirect";

const routes = [
    {
        path: '/',
        name: 'Index',
        component: Login,
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
    },
    {
        path: '/assinatura-gestao',
        redirect: (to) => ({
            path: '/subscription/ativar-gestao',
            query: to.query,
        }),
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
            auth: false,
            layout: 'guest-layout',
            title: 'Alterar Senha',
        }
    },
    {
        path: '/auth/impersonate',
        name: 'ImpersonateLogin',
        component: ImpersonateLogin,
        meta: {
            auth: false,
            layout: 'guest-layout',
            title: 'Acesso de suporte',
        }
    },
    {
        path: '/setup-two-factor',
        name: 'SetupTwoFactor',
        component: SetupTwoFactor,
        meta: {
            auth: true,
            layout: 'guest-layout',
            title: 'Configurar 2FA',
        }
    },
    {
        path: '/invite',
        name: 'InviteRedirect',
        component: InviteRedirect,
        meta: {
            auth: false,
            layout: 'guest-layout',
            title: 'Convite',
        }
    },
    {
        path: '/places/:placeId/user-invite/:inviteId/:action',
        name: 'InviteUserAction',
        component: InviteUserAction,
        meta: {
            auth: false,
            layout: 'guest-layout',
            title: 'Convite de Usuário',
        }
    },
    {
        path: '/places/:placeId/professional-invite/:inviteId/:action',
        name: 'InviteProfessionalAction',
        component: InviteProfessionalAction,
        meta: {
            auth: false,
            layout: 'guest-layout',
            title: 'Convite de Profissional',
        }
    },
];

export default routes
